export default __webpack_public_path__ + "static/media/tooltip-q.724af5f2.svg";